import { render, staticRenderFns } from "./TerrenoJuegoComponent.vue?vue&type=template&id=fb9613ae&scoped=true"
import script from "./TerrenoJuegoComponent.vue?vue&type=script&lang=js"
export * from "./TerrenoJuegoComponent.vue?vue&type=script&lang=js"
import style0 from "./TerrenoJuegoComponent.vue?vue&type=style&index=0&id=fb9613ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb9613ae",
  null
  
)

export default component.exports